export var cardTopControlsStyles = {
  root: function root(_ref) {
    var v = _ref.variables;
    return {
      position: 'absolute',
      top: v.topControlsTop,
      right: v.topControlsRight
    };
  }
};